import { type LocationBillingType, type PaymentMethods } from '@a1/shared';
import { type PaymentStatus, type InvoicePaymentOption } from 'types/invoice';

const locationBillingTypes: Record<string, LocationBillingType> = Object.freeze({
  Default: {
    label: 'Default',
    value: 'default'
  },
  Regional: {
    label: 'Regional Variant',
    value: 'regional'
  }
});

const paymentMethods: Record<string, PaymentMethods> = Object.freeze({
  ONLINE: {
    id: 'ONLINE',
    label: 'Online'
  },
  INVOICE: {
    id: 'INVOICE',
    label: 'Invoice'
  }
});

const invoicePaymentOption: Record<string, InvoicePaymentOption> = Object.freeze({
  ONLINE: {
    id: 'ONLINE',
    label: 'Online'
  },
  INVOICE: {
    id: 'INVOICE',
    label: 'Invoice'
  }
});

const invoiceStatusAction: Record<string, string> = Object.freeze({
  MARK_AS_PAID: 'MARK_AS_PAID',
  MARK_AS_AWAITING_PAYMENT: 'MARK_AS_AWAITING_PAYMENT',
  REFUNDED: 'REFUNDED',
  VOID: 'VOID'
});

const paymentStatusAction: Record<string, string> = Object.freeze({
  MARK_AS_PAID: 'MARK_AS_PAID',
  MARK_AS_AWAITING_PAYMENT: 'MARK_AS_AWAITING_PAYMENT',
  REFUNDED: 'REFUNDED'
});

const paymentStatuses: Record<string, PaymentStatus> = Object.freeze({
  AWAITING_PAYMENT: {
    id: 'AWAITING_PAYMENT',
    label: 'Awaiting payment'
  },
  PAID: {
    id: 'PAID',
    label: 'Paid'
  },
  REFUNDED: {
    id: 'REFUNDED',
    label: 'Refunded'
  },
  VOID: {
    id: 'VOID',
    label: 'Void'
  }
});

export { locationBillingTypes, paymentMethods, invoiceStatusAction, paymentStatuses, paymentStatusAction, invoicePaymentOption };
